<div class="content-component">
  <ng-content></ng-content>
</div>
